"use strict";

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _Header = _interopRequireDefault(require("./Header/Header"));

var _Sidebar = _interopRequireDefault(require("./Sidebar/Sidebar"));

var _wrapperSidebarContext = require("./wrapperSidebarContext");

var S = _interopRequireWildcard(require("./Wrapper.styles"));

var _sidebarTheme = require("./sidebarTheme");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _ref => {
  var {
    session,
    permisos,
    data,
    logout,
    redirectTo,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_wrapperSidebarContext.WrapperSidebarContextProvider, {
    session: session,
    permisos: permisos,
    data: data,
    logout: logout,
    redirectTo: redirectTo
  }, /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: _sidebarTheme.sidebarTheme
  }, /*#__PURE__*/_react.default.createElement(S.Wrapper, null, session.id // Para no renderizar el header y sidebar en la pantalla de login
  ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Header.default, null), /*#__PURE__*/_react.default.createElement(_Sidebar.default, null)) : /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement(S.CurrentRouteContent, null, children))));
};

var _default = Wrapper;
exports.default = _default;